.fl {
	display: flex;
}

.fl[data-view="list"] {
	flex-direction: column;
}

.fl[data-view="grid"] {
	flex-direction: row;
	flex-wrap: wrap;
	gap: 5px;
}

.fl_uploader_input {
	display: none;
}

.fl_preview_modal {

	&:global(.ant-modal) {

		:global {

			.ant-modal-body {
				padding: 0;
				padding-bottom: 0 !important;
			}

			.ant-modal-footer {
				display: none;
				padding: 0;
			}

			.ant-modal-close {
				top: 3px;
				right: 3px;

				border-radius: 50%;

				color: #fff;

				background: rgba(0, 0, 0, 0.25);

				&:hover {

					.ant-modal-close-x {
						color: #fff;
					}
				}

				.ant-modal-close-x {
					width: 40px;
					height: 40px;
					line-height: 40px;
					color: #fff;
				}
			}
		}
	}
}
